<template>
  <div class="box kpi-card">
    <div class="kpi-header mb-3">
      <b-icon v-if="icon" :icon="icon" class="mr-2" />

      <h3 class="title is-6 mb-0" v-html="title" />
    </div>

    <hr class="kpi-divider" />

    <div class="kpi-values is-flex is-align-items-baseline">
      <span class="kpi-value" :style="{ color: valueColor }">
        {{ value || "-" }}
      </span>

      <span v-if="extra" class="kpi-extra ml-3">
        {{ extra }}
      </span>
    </div>

    <p
      v-if="subtitle"
      class="is-size-7 has-text-grey kpi-subtitle"
      v-tooltip="subtitle"
    >
      {{ subtitle }}
    </p>
  </div>
</template>

<script>
export default {
  name: "KpiCard",

  props: {
    title: {
      type: String,
      required: true,
    },

    value: {
      type: [String, Number],
      required: true,
    },

    subtitle: {
      type: String,
      default: "",
    },

    extra: {
      type: String,
      default: "",
    },

    icon: {
      type: String,
      default: "",
    },

    valueColor: {
      type: String,
      default: "inherit",
    },
  },
};
</script>

<style scoped>
.kpi-divider {
  margin: 0.5rem 0 1rem;
}

.kpi-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.kpi-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.kpi-header .title {
  min-width: 0;
  overflow-wrap: break-word;
  word-break: normal;
  /* Título más pequeño para que los nombres largos ("Sin consentimiento")
     ocupen menos líneas y las tarjetas se vean más parejas. */
  font-size: 0.9rem;
}

.kpi-value {
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1;
}

.kpi-extra {
  font-size: 0.875rem;
  color: #656565;
  font-weight: 400;
}

.kpi-values {
  margin-bottom: 0.5rem;
}

/* Subtítulo pegado al fondo → alinea la última línea entre todas las tarjetas. */
.kpi-card > p {
  margin-top: auto;
  margin-bottom: 0;
}

/* Texto secundario en una sola línea con ellipsis (el texto completo se
   muestra en el tooltip). */
.kpi-subtitle {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/kpiCard.vue